import { Component, EventEmitter, Input, OnInit, Output, } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { Bonocliente } from '../../../../models/bonocliente';
import { DataCombo } from '../../../../models/combo';
import { TicketService } from '../../../../services/ticket.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-tabla-servicios-ticket',
  templateUrl: './tabla-servicios-ticket.component.html',
  styleUrls: ['./tabla-servicios-ticket.component.scss']
})
export class TablaServiciosTicketComponent implements OnInit {

  @Input() eventServicioDetalles: FormArray;
  @Input() tForm: FormGroup;
  @Input() bcServicios: Bonocliente[];;
  @Input() usuariosCombo: DataCombo[];
  @Input() bonosPorServicio: { [servicioId: number]: Bonocliente[] } = {};
  @Input() esDetalle: boolean = false;

  @Output() sendToastMsg: EventEmitter<object> = new EventEmitter<object>();
  @Output() updateImporteTotal: EventEmitter<boolean> = new EventEmitter<boolean>();

  hoveredNombre: string | null = null;

  constructor(
    private ticketService: TicketService,
    private translate: TranslateService) { }

  ngOnInit(): void {
  }

  getNombreUsuario(userId: number): string {
    return this.usuariosCombo?.find(u => u.value === userId)?.label || 'Usuario eliminado';
  }

  esPrimeraUnidad(nombre: string, index: number): boolean {
    const controles = this.eventServicioDetalles.controls;
    for (let i = 0; i < index; i++) {
      if (controles[i].value.nombre === nombre) {
        return false;
      }
    }
    return true;
  }

  cantidadDelServicio(nombre: string): number {
    return this.eventServicioDetalles.controls.filter(g => g.value.nombre === nombre).length;
  }

  onBcServicioSeleccionado(index: number): void {
    const grupo = this.eventServicioDetalles.at(index);
    const bonoclienteId = grupo.get('bonoclienteId')?.value;

    if (!bonoclienteId) {
      return;
    }

    const bonocliente = this.bcServicios.find(b => b.id === bonoclienteId);

    if (bonocliente) {
      // Contar cuántas veces ya se está usando este bono en otros servicios
      // (excluyendo el servicio actual donde lo estamos aplicando)
      const vecesUsado = this.eventServicioDetalles.controls.filter((ctrl, idx) => {
        return idx !== index && ctrl.get('bonoclienteId')?.value === bonoclienteId;
      }).length;

      // Verificar si aún hay sesiones disponibles
      const sesionesDisponibles = bonocliente.saldo - vecesUsado;

      if (sesionesDisponibles <= 0) {
        // No hay sesiones disponibles, revertir la selección
        grupo.patchValue({
          bonoclienteId: null,
          descuentoBono: 0
        }, { emitEvent: true });

          this.sendToastMsg.emit({
            mensajeError: true,
            mensaje: this.translate.instant('mensajes.tickets.sinSesiones', {saldo: bonocliente.saldo, usadas: vecesUsado})
          });

        // Mostrar mensaje de error (puedes adaptar esto según tu sistema de notificaciones)
        // alert(`El bono seleccionado no tiene sesiones disponibles. Sesiones restantes: ${bonocliente.saldo}, ya aplicadas: ${vecesUsado}`);

        setTimeout(() => {
          this.updateImporteTotal.emit(true);
        }, 0);
        return;
      }

      const precio = grupo.value.precio;
      const descuento = precio;

      // Aplicar el descuento de forma explícita
      grupo.patchValue({ descuentoBono: descuento }, { emitEvent: true });

      // Forzar recálculo inmediato
      setTimeout(() => {
        this.updateImporteTotal.emit(true);
      }, 0);
    }
  }

  eliminarBonoServicio(index: number): void {
    const grupo = this.eventServicioDetalles.at(index);
    grupo.patchValue({
      bonoclienteId: null,
      descuentoBono: 0
    }, { emitEvent: true });

    // Forzar recálculo inmediato
    setTimeout(() => {
      this.updateImporteTotal.emit(true);
    }, 0);
  }

  activarModoManual(index: number): void {
    const grupo = this.eventServicioDetalles.at(index);

    grupo.patchValue({
      modoBono: 'manual',
      bonoclienteId: null,
      descuentoBono: 0,
      bonoCodigoManual: '',
      bonoManualError: ''
    });
    this.updateImporteTotal.emit(true);
    // this.calcularImporteTotal();
  }

  validarBonoManual(index: number): void {
    const grupo = this.eventServicioDetalles.at(index);
    const codigo = grupo.get('bonoCodigoManual')?.value;
    const servicioId = grupo.get('servicioId')?.value;

    this.ticketService.comprobarBonoDescuento(codigo, servicioId).subscribe(res => {
      const [bonocliente, servicio, ticket, msg] = res;

      if (msg[0] === true && bonocliente) {
        // Obtener lo que ya estaba descontado en este FormGroup específico
        const descuentoPrevio = grupo.get('descuentoBono')?.value || 0;

        // Sumar las sesiones previas al saldo actual del backend
        const saldoAjustado = bonocliente.sesionesDisponibles + (descuentoPrevio > 0 ? 1 : 0);

        // Contar cuántas veces ya se está usando este bono en otros servicios
        // (excluyendo el servicio actual)
        const vecesUsado = this.eventServicioDetalles.controls.filter((ctrl, idx) => {
          return idx !== index && ctrl.get('bonoclienteId')?.value === bonocliente.id;
        }).length;

        // Verificar si aún hay sesiones disponibles
        const sesionesDisponibles = saldoAjustado - vecesUsado;

        if (sesionesDisponibles <= 0) {
          // No hay sesiones disponibles
          grupo.patchValue({
            bonoclienteId: null,
            descuentoBono: 0,
            bonoCodigoManual: '',
            bonoManualError: `El bono no tiene sesiones disponibles. Sesiones restantes: ${saldoAjustado}, ya aplicadas: ${vecesUsado}`
          });
          this.updateImporteTotal.emit(true);
          return;
        }

        grupo.patchValue({
          bonoclienteId: bonocliente.id,
          descuentoBono: grupo.value.precio,
          bonoCodigoManual: '',
          modoBono: 'selector'
        });
        this.updateImporteTotal.emit(true);
      }
    });
  }

  activarModoSelector(index: number): void {
    const grupo = this.eventServicioDetalles.at(index);

    grupo.patchValue({
      modoBono: 'selector',
      bonoCodigoManual: '',
      bonoManualError: ''
    });
    this.updateImporteTotal.emit(true);
    // this.calcularImporteTotal();
  }

  financiar(index: number): void {
    const grupo = this.eventServicioDetalles.at(index);
    const precio = grupo.get('precio')?.value;
    const numPlazos = grupo.get('numPlazos')?.value;

    if (!precio || !numPlazos || numPlazos <= 1) {
      grupo.get('numPlazos')?.setErrors({ invalid: true });
      return;
    }

    const precioPlazo = +(precio / numPlazos).toFixed(2);

    grupo.patchValue({
      financiado: true,
      numPlazos: numPlazos,
      precioPlazo
    });
    this.updateImporteTotal.emit(true);
    // this.calcularImporteTotal();
  }

  eliminarFinanciacion(index: number): void {
    const grupo = this.eventServicioDetalles.at(index);

    grupo.patchValue({
      financiado: false,
      numPlazos: null,
      precioPlazo: null
    });
    this.updateImporteTotal.emit(true);
    // this.calcularImporteTotal();
  }

  onHover(nombre: string) {
    this.hoveredNombre = nombre;
  }

  onLeave() {
    this.hoveredNombre = null;
  }

  getNombreBono(id: number): string {
    // Buscar en todos los arrays de bonosPorServicio
    for (const servicioId in this.bonosPorServicio) {
      const bono = this.bonosPorServicio[servicioId].find(b => b.id === id);
      if (bono && bono.bono?.baseBono?.name) {
        return bono.bono?.baseBono?.name; // Ya viene formateado como "codigo - nombre"
      }
    }

    // Si no se encuentra, buscar en bcServicios como fallback
    const bono = this.bcServicios?.find(b => b.id === id);
    if (bono) {
      const codigo = bono.codigo?.toString().padStart(6, '0');
      const nombre = bono.bono?.baseBono?.name ?? 'Sin nombre';
      return `${codigo} - ${nombre}`;
    }

    return 'Bono desconocido';
  }
}
